import BaseAPI from "../api";

const path: string = "student-registration-admin";

export class StudentRegistrationAdminApi extends BaseAPI {
  static getList(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static getListAll(query?: any): Promise<any> {
    return this.api.get(`${path}/all`, {
      params: { ...query },
    });
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
}
